exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-outfits-message[data-v-03aa1d4f] {\n  position: absolute;\n  top: calc(50% - 40px);\n  width: 70%;\n  left: 15%;\n  font-size: 20px;\n  text-align: center;\n  font-weight: 300;\n}", ""]);

// exports
